import { inject, Injectable, NgZone } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { EventSourcePolyfill, EventSourcePolyfillInit } from 'event-source-polyfill';
import { AuthStore } from '@app/store/auth.store';

@Injectable({
  providedIn: 'root',
})
export class FirmwareSSEService {
  private eventSource?: EventSource;
  private readonly authStore;

  constructor(private readonly zone: NgZone) {
    this.authStore = inject(AuthStore);
  }

  getEventSource(url: string, options: EventSourcePolyfillInit): EventSource {
    const token = this.authStore.authInfo().access_token;
    options = { ...options, headers: { ...options.headers, Authorization: `Bearer ${token}` } };
    return new EventSourcePolyfill(url, options);
  }

  connectEventSource(
    url: string,
    options: EventSourcePolyfillInit,
    eventNames: string[] = [],
  ): Observable<any> {
    const eventSource = this.getEventSource(url, options);
    this.eventSource = eventSource;

    return new Observable((subscriber: Subscriber<Event>) => {
      const handlers = new Map<string, EventListener>();

      eventSource.onerror = error => {
        this.zone.run(() => subscriber.error(error));
      };

      eventNames.forEach((event: string) => {
        const handler: EventListener = data => {
          this.zone.run(() => subscriber.next(data));
        };
        handlers.set(event, handler);
        eventSource.addEventListener(event, handler);
      });

      return () => {
        eventSource.onerror = null;
        handlers.forEach((handler, event) => {
          eventSource.removeEventListener(event, handler);
        });
        eventSource.close();

        if (this.eventSource === eventSource) {
          this.eventSource = undefined;
        }
      };
    });
  }
}
